import {h, Fragment} from "preact"
import { useLoadMore, useSizeOptions } from "@nosto/preact"
import { defaultConfig, sizes } from "../config"

export default function () {
    const { loadMore } = useLoadMore(defaultConfig.serpSize)
    const { to, total } = useSizeOptions(sizes, defaultConfig.serpSize)

    return (
        <div className="ns-load-more flex flex-col justify-center items-center w-full">
            <div className="ns-load-more-label">
                You've viewed {total < to ? total : to} of {total} {(total === 1 || to === 1) ? 'product' : 'products'}
            </div>
            {to < total &&
                <button
                    className="ns-load-more-button cta-btn flex justify-center items-center h-full text-center"
                    aria-label="Load more products"
                    onClick={loadMore}
                >
                    Load More
                </button>
            }
        </div>
    )
}